import { IDetection, IParamsURL } from '../uanc.types';
import { isCookiesEnabled } from './cookies';

export const getBrowserType = (userAgent: string): string | null => {
    switch (true) {
        case typeof window.safari !== 'undefined' && typeof window.safari.pushNotification !== 'undefined':
            return 'safari';
        case /CriOS/i.test(userAgent):
        case /Chrome/i.test(userAgent) && !/OPR|Edge|Edg/i.test(userAgent):
            return 'chrome';
        case /Firefox|FxiOS/i.test(userAgent):
            return 'firefox';
        case /OPR\//i.test(userAgent):
        case /Opera/i.test(userAgent):
            return 'opera';
        case /Edg/i.test(userAgent):
            return 'edge';
        case /MSIE|Trident/i.test(userAgent):
            return 'internet explorer';
        case /Safari/i.test(userAgent) && !/Chrome|OPR|Edge|Edg/i.test(userAgent):
            return 'safari';
        default:
            return null;
    }
};

export const getDevice = (userAgent: string): string | null => {
    const devices: { [key: string]: string } = {
        'Windows Phone': 'windowsphone',
        Android: 'android',
        webOS: 'webos',
        iPhone: 'iphone',
        iPad: 'ipad',
        iPod: 'ipod',
        BlackBerry: 'blackberry',
        'Mac OS': 'macos',
        Linux: 'linux',
        X11: 'unix',
        Windows: 'windows',
    };

    for (const [key, value] of Object.entries(devices)) {
        if (userAgent.indexOf(key) > -1) {
            return value;
        }
    }

    return null;
};

export const getAdKeywords = (): string | null => {
    const {
        location: { search },
    } = window;
    const params = new URLSearchParams(search);
    return params.get('__ad_keywords');
};

export const getPageURI = (location: Location): string => {
    const { href, protocol, host } = location;
    const regExp = /[^a-zA-Z0-9-]/g;

    return host + href.replace(`${protocol}//${host}`, '').replace(regExp, ',');
};

export const getPageURI2 = (location: Location): string => {
    const { href, protocol } = location;
    const regExp = /[^a-zA-Z0-9\-/:.#]/g;

    return href.replace(`${protocol}//`, '').replace(regExp, '_');
};

export const getParamsURL = (url: string): IParamsURL => {
    const urlObj = new URL(url);
    const paramsURL = new URLSearchParams(urlObj.search);

    const params: IParamsURL = {};
    for (const [key, value] of paramsURL) {
        params[key] = value;
    }

    return params;
};

export const getDetection = (): IDetection => {
    const userAgent = navigator.userAgent;
    const location = window.location;
    const browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) && browserWidth < 1000;
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const libraryPath = process.env.PATH ?? `js.iplsc.com/inpl.nuanc/${process.env.npm_package_version}`;
    const libraryHost = process.env.HOST ?? 'js.iplsc.com';

    return {
        browserWidth,
        browser: getBrowserType(userAgent),
        device: getDevice(userAgent),
        isMobile,
        isMobileDevice,
        adKeywords: getAdKeywords(),
        isCookieEnable: isCookiesEnabled(),
        libraryPath,
        libraryHost,
        host: location.host,
        hostName: location.hostname,
        protocol: location.protocol,
        url: location.href,
        pageURI: getPageURI(location),
        pageURI2: getPageURI2(location),
        params: getParamsURL(location.href),
    };
};
